import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { NovoCustomerShareIndicadorMultiselectComponent } from './novo-customer-share-indicador-multiselect.component';

@NgModule({
  imports: [SharedModule],
  declarations: [NovoCustomerShareIndicadorMultiselectComponent],
  exports: [NovoCustomerShareIndicadorMultiselectComponent]
})
export class NovoCustomerShareIndicadorMultiselectModule {}
